<template>
    <i class="ico-svg-smile">
        <svg v-bind="{ width, height }" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.227.364C21.758.364 27.864 6.469 27.864 14c0 7.531-6.106 13.636-13.637 13.636C6.697 27.636.591 21.531.591 14 .59 6.469 6.696.364 14.227.364zm0 1.704C7.637 2.068 2.295 7.41 2.295 14c0 6.59 5.343 11.932 11.932 11.932 6.59 0 11.932-5.342 11.932-11.932 0-6.59-5.342-11.932-11.932-11.932zm5.907 14.484a.852.852 0 01.738 1.283 7.67 7.67 0 01-6.645 3.835 7.667 7.667 0 01-6.644-3.835.852.852 0 111.476-.852 5.963 5.963 0 005.168 2.983 5.962 5.962 0 005.168-2.983.852.852 0 01.74-.431zm-9.316-9.37c.942 0 1.705.763 1.705 1.704v.198a7.21 7.21 0 011.704-.198 7.193 7.193 0 011.705.198v-.198c0-.941.763-1.704 1.704-1.704h4.637A1.705 1.705 0 0123.924 9.3l-.53 2.117A3.41 3.41 0 0120.088 14h-.747a3.41 3.41 0 01-3.399-3.135c-.453-.165-1.045-.274-1.715-.274a5.097 5.097 0 00-1.715.274A3.41 3.41 0 019.114 14h-.749a3.41 3.41 0 01-3.306-2.582L4.529 9.3a1.705 1.705 0 011.653-2.12z" :fill="color" />
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconSmile',

    props: {
        width: {
            type: Number,
            default: 28,
        },

        height: {
            type: Number,
            default: 28,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
